"use client";
import { IconRadioActive, IconStepperInactive } from "@repo/assets/images";
import {
  AddressActionsIcon,
  AddressDropdownMenu,
} from "@repo/components/account/address-book";
import { useClickOutside } from "@repo/lib/hooks/common";
import { deleteAddress } from "@repo/server-actions/account";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useCallback, useMemo, useRef, useState, useTransition } from "react";

const AddressCard = ({
  item,
  selectedAddress,
  handleSelectedAddress,
  isCheckout,
  session,
  handleEditAddressForm,
}) => {
  const t = useTranslations("Common");
  const { firstName, lastName, line1, street, city, zipCode } = item;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const [isPending, startTransition] = useTransition();

  const handleDropdown = useCallback(() => setIsOpen((prev) => !prev), []);

  const handleCloseDropdown = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleDeleteAddress = useMemo(
    () => async (itemId) => {
      startTransition(async () => {
        await deleteAddress(itemId, session);
      });
    },
    [session]
  );

  useClickOutside(dropdownRef, handleCloseDropdown);

  return (
    <label
      className={cx("border-supportiveDarkGray relative border", {
        "cursor-pointer": isCheckout,
      })}
      htmlFor={item?.id}
    >
      <div className="px-3 pt-3 text-sm font-medium md:text-base">
        {isCheckout ? (
          <span className="font-heading rtl:font-arabic flex items-center font-medium">
            {selectedAddress?.id === item?.id ? (
              <IconRadioActive className="text-icon-color me-3 fill-current" />
            ) : (
              <IconStepperInactive className="text-icon-color me-3 fill-current" />
            )}
            {item?.title || t("Home_Address")}
            <AddressActionsIcon onClick={handleDropdown} />
          </span>
        ) : (
          <span className="font-heading rtl:font-arabic flex items-center font-medium">
            {item?.title || t("Home_Address")}
            <AddressActionsIcon onClick={handleDropdown} />
          </span>
        )}
        {isCheckout && (
          <input
            id={item?.id}
            aria-labelledby={item?.id}
            type="radio"
            checked={selectedAddress?.id === item?.id}
            onChange={() => {
              if (isCheckout) {
                handleSelectedAddress(item);
              }
            }}
            name="checkout_shipping_address"
            hidden
          />
        )}
      </div>
      <ul className="p-3 text-sm tracking-wider">
        <li className="pb-2 text-sm font-semibold md:text-base">
          {firstName} {lastName}
        </li>
        <li>{line1}</li>
        <li>{street}</li>
        <li>{city}</li>
        <li>{zipCode}</li>
        <li>Country: Saudi Arabia</li>
      </ul>
      {isOpen && (
        <AddressDropdownMenu
          dropdownRef={dropdownRef}
          onEdit={() => {
            setIsOpen(false);
            handleEditAddressForm(item);
          }}
          onDelete={() => handleDeleteAddress(item?.id)}
          isPending={isPending}
          t={t}
        />
      )}
    </label>
  );
};

export default AddressCard;
